Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInput = void 0;
var _useBreakpoints2 = require("./useBreakpoints");
var _getREM = require("../../getREM");
var _FontSize = require("../FontSize");
var _useColors2 = require("./useColors");
var _Grid = require("../Grid");
var _useSpacing2 = require("./useSpacing");
var _useFont2 = require("./useFont");
var useInput = exports.useInput = function useInput() {
  var _useBreakpoints = (0, _useBreakpoints2.useBreakpoints)(),
    bp = _useBreakpoints.bp;
  var _useColors = (0, _useColors2.useColors)(),
    COLORS = _useColors.COLORS;
  var _useSpacing = (0, _useSpacing2.useSpacing)(),
    spacing = _useSpacing.spacing;
  var _useFont = (0, _useFont2.useFont)(),
    fontRegular = _useFont.fontRegular;
  var input_base = Object.assign({}, fontRegular, {
    width: '100%',
    height: (0, _getREM.getREM)(2.625),
    fontSize: _FontSize.fontSize.normal,
    lineHeight: _FontSize.lineHeight.normal,
    borderRadius: (0, _getREM.getREM)(2.625 / 2),
    borderWidth: (0, _getREM.getREM)(0.0625),
    borderColor: COLORS.mercury,
    borderStyle: 'solid',
    paddingTop: spacing.xs,
    paddingBottom: spacing.xs,
    paddingLeft: spacing.l,
    paddingRight: spacing.l,
    maxWidth: _Grid.grid.maxInputWidth,
    color: COLORS.aubergine,
    backgroundColor: COLORS.paper,
    textAlign: 'left',
    overflow: 'hidden'
  });
  if (bp.is([bp.mobile_xs, bp.mobile_s, bp.mobile_normal, bp.mobile_m])) {
    input_base.paddingLeft = spacing.normal;
    input_base.paddingRight = spacing.normal;
  }
  var input = Object.assign({}, input_base);
  if (bp.desktop) {
    input.height = (0, _getREM.getREM)(3.875);
    input.borderRadius = (0, _getREM.getREM)(3.875 / 2);
    input.fontSize = _FontSize.fontSize.m;
    input.lineHeight = _FontSize.lineHeight.m;
    input.paddingTop = spacing.m;
    input.paddingBottom = spacing.m;
  }
  return {
    input: input,
    input_base: input_base
  };
};